<template>
  <context-bar-and-content class="referral-list" :display-footer="false">
    <template slot="context-bar-full">
      <el-row :gutter="18" class="tallies">
        <el-col :md="24" class="tally-wrapper">
          <span class="tally" v-loading="tallyIsLoading" element-loading-background="rgba(0, 0, 0, 0)">
            <strong>Total:</strong> {{ tally.total }}
          </span>
          <span class="tally" v-loading="tallyIsLoading" element-loading-background="rgba(0, 0, 0, 0)">
            <strong>Approved:</strong> {{ tally.approved }}
          </span>
          <span class="tally" v-loading="tallyIsLoading" element-loading-background="rgba(0, 0, 0, 0)">
            <el-tooltip class="item" effect="dark" content="Count of Referrals that are both Approved and Unpaid" placement="bottom">
              <i class="el-icon-question ml-3"></i>
            </el-tooltip>
            <strong>Ready to Pay:</strong> {{ readyToPayCount }}
          </span>
          <span class="tally" v-loading="tallyIsLoading" element-loading-background="rgba(0, 0, 0, 0)">
            <el-tooltip class="item" effect="dark" content="Total incentive amount from referrals that are 'Ready to Pay'" placement="bottom">
              <i class="el-icon-question ml-3"></i>
            </el-tooltip>
            <strong>Pending Total:</strong> {{ pendingTotal }}
          </span>
        </el-col>
      </el-row>
    </template>

    <searchable-grid class="grid-wrap" ref="grid" title="Referrals" :column-defs="columnDefs" :get-rows-promise="getRows" @cellDoubleClicked="onCellDoubleClicked">
      <template slot="actions">
        <el-select
          style="width: 300px; margin-right: 18px"
          v-model="selectedOfficeId"
          :clearable="selectedOfficeId !== null"
          placeholder="Filter By Office" v-if="allOffices.length > 1">
          <el-option
            v-for="item in allOffices"
            :key="item.id"
            :label="'#' + item.storeNum + ' - ' + item.address"
            :value="item.id">
          </el-option>
        </el-select>
      </template>
    </searchable-grid>
  </context-bar-and-content>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import api from '@/api';
import ContextBarAndContent from '@/components/layout/ContextBarAndContent.vue';
import SearchableGrid from '@/components/grid/SearchableGrid.vue';
import BoolFilter from '@/components/grid/BoolFilter';

export default {
  data() {
    return {
      selectedOfficeId: null,
      tallyIsLoading: false,
      tally: {
        approved: undefined,
        total: undefined,
        paid: undefined,
        pendingPayoutAmount: undefined,
      },
      columnDefs: [
        {
          headerName: '#',
          width: 50,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          pinned: true,
        },
        {
          headerName: 'Referrer',
          cellRenderer: (params) => {
            if (params.data !== undefined) {
              return params.data.referrerName;
            }
            return '<i class="el-icon-loading"></i>';
          },
        },
        {
          headerName: 'Referrer\'s Phone',
          field: 'referrerPhone',
        },
        {
          headerName: 'New Client SSN',
          field: 'newClientSSN',
        },
        {
          headerName: 'New Client Name',
          field: 'newClientName',
        },
        {
          headerName: 'Status',
          field: 'statusName',
        },
        {
          headerName: 'Amount',
          field: 'amount',
        },
        {
          headerName: 'Paid',
          field: 'paid',
          valueFormatter(cell) {
            if (cell.value === undefined) return '';

            return cell.value ? 'Yes' : 'No';
          },
          filter: BoolFilter,
        },
        {
          headerName: 'Date added',
          field: 'dateAdded',
        },
        {
          headerName: 'Office',
          field: 'officeEfin',
        },
      ],
    };
  },
  methods: {
    ...mapActions('Lookup', ['getOffices']),
    getRows(params) {
      if (this.selectedOffice) {
        params.filterModel = {
          ...params.filterModel,
          ...{
            officeEfin: {
              filter: this.selectedOffice.efin,
              filterType: 'text',
              type: 'equals',
            },
          },
        };
      }
      return api.referral.getGridData(params);
    },
    getTally() {
      this.tallyIsLoading = true;
      let officeId = null;
      if (this.selectedOffice) {
        officeId = this.selectedOffice.id;
      }
      return api.referral.getTally(officeId).then((response) => {
        this.tally = response.data;
      }).finally(() => {
        this.tallyIsLoading = false;
      });
    },
    onCellDoubleClicked(event) {
      if (event.data && event.data.id) {
        // this.$router.push({ name: 'officeDetail', params: { officeId: event.data.id } });
      }
    },
  },
  computed: {
    ...mapGetters('Lookup', ['allOffices', 'officeMap']),
    selectedOffice() {
      if (this.selectedOfficeId == null) {
        return null;
      }
      return this.officeMap[this.selectedOfficeId];
    },
    readyToPayCount() {
      const totalApproved = this.tally.approved || 0;
      const totalPaid = this.tally.paid || 0;

      const result = totalApproved - totalPaid;

      return result;
    },
    pendingTotal() {
      if (this.tally.pendingPayoutAmount) {
        return `$${this.tally.pendingPayoutAmount}`;
      }
      return '';
    },
  },
  watch: {
    selectedOfficeId() {
      this.getTally();
      this.$refs.grid.refreshSearch();
    },
  },
  mounted() {
    this.getTally();
    this.getOffices();
  },
  components: {
    SearchableGrid,
    ContextBarAndContent,
  },
};

</script>

<style lang="scss" scoped>

.grid-wrap {
  width: calc(100% - 36px);
  padding: 18px;
}

.tallies {
  width: 100%;

  .tally-wrapper {
    display: flex;
    justify-content: space-between;

    .tally {
      flex: 1 1 auto;
    }
  }
}

</style>
